import {ChangeDetectionStrategy, Component, inject, OnInit, signal, computed, effect, viewChild} from '@angular/core';
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell, MatHeaderCellDef,
    MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef,
    MatTable,
    MatTableDataSource
} from "@angular/material/table";
import {Task, TaskGroupDetails, TaskService} from "../../../services/task.service";
import {Constants} from "../../../util/constants";
import {ActivatedRoute, Router} from "@angular/router";
import {BusyService} from "../../../services/busy.service";
import {finalize} from "rxjs/operators";
import { HttpErrorResponse } from "@angular/common/http";
import {AlertService} from "../../../services/alert.service";

@Component({
    imports: [
        MatPaginator,
        MatCell,
        MatCellDef,
        MatColumnDef,
        MatHeaderCell,
        MatTable,
        MatHeaderRow,
        MatHeaderRowDef,
        MatRow,
        MatRowDef,
        MatHeaderCellDef
    ],
    templateUrl: './task-details.component.html',
    styleUrl: './task-details.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TaskDetailsComponent implements OnInit {

    paginator = viewChild<MatPaginator>('paginator');
    groupDetails = signal<TaskGroupDetails|undefined>(undefined);
    totalTaskCount = computed(() => this.groupDetails()? this.groupDetails()!.total_task_count : 0);
    dataSource = computed(() =>
        new MatTableDataSource<Task>(this.groupDetails()? this.groupDetails()!.tasks : [])
    );

    readonly PAGE_SIZE_OPTIONS = [5, 10, 20];
    readonly DEFAULT_PAGE_SIZE = this.PAGE_SIZE_OPTIONS[1];
    readonly COLUMNS_TO_DISPLAY = ['id', 'domain', 'completed', 'last_failed', 'failures'];

    private taskService = inject(TaskService);
    private route = inject(ActivatedRoute);
    private router = inject(Router);
    private busyService = inject(BusyService);
    private alertService = inject(AlertService);

    groupId = this.route.snapshot.params['group_id'];

    ngOnInit(): void {
        this.getTasks(0, this.DEFAULT_PAGE_SIZE);
    }

    onPageChange(event: PageEvent): void {
        this.getTasks(event.pageIndex*event.pageSize, event.pageSize);
    }

    private getTasks(offset: number, limit: number) {
        this.busyService.showBusy();
        this.taskService.getGroupDetails(this.groupId, offset, limit).pipe(
            finalize(() => this.busyService.showNotBusy()),
        ).subscribe({
            next: (details: TaskGroupDetails) => {
                this.groupDetails.set(details);
            },
            error: (err: HttpErrorResponse) => {
                console.error(err);
                this.alertService.error("Error retrieving task group details: " + err.message)
            }
        });
    }

    backToBulk() {
        this.router.navigateByUrl('/bulk').then();
    }

    formatTimestamp(timestamp: number): string {
        return timestamp? Constants.US_TIMESTAMP_FORMAT.format(new Date(timestamp)) : "";
    }
}
